var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.563 11.071"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m11.549 10.592.478.478 5.535-5.535L12.028 0l-.478.478 4.715 4.715H0v.683h16.265Z",
    "data-name": "Path 14183"
  })));
};
export default SvgRightArrow;